/* eslint-disable jsx-a11y/label-has-associated-control */
import { v4 as uuidv4 } from "uuid";
import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Condition from "./Condition";
import Context from "../../../../store/context";
import HelpButton from "../../../../HelpContent/HelpButton";
import { faMinusCircle, faPlusCircle } from "@fortawesome/free-solid-svg-icons";

export default function Conditions({ ruleState, setConditions, event }) {
  const { isModalSidebar } = useContext(Context);
  const state = [...(ruleState.Conditions || [])].sort(
    (a, b) => a.Order - b.Order
  );
  const dispatch = (action) => {
    switch (action.type) {
      case "addCondition":
        setConditions(
          [
            ...state,
            {
              UUID: uuidv4(),
              Logical: "AND",
              Options: [],
            },
          ].map((a, index) => ({ ...a, Order: index }))
        );
        break;
      case "removeCondition":
        setConditions(
          state
            .filter((c) => action.conditionId !== c.UUID)
            .map((a, index) => ({ ...a, Order: index }))
        );
        break;
      case "edit-condition":
        setConditions(
          state
            .map((condition) => {
              if (condition.UUID === action.data.UUID) {
                return action.data;
              }
              return condition;
            })
            .map((a, index) => ({ ...a, Order: index }))
        );
        break;
      default:
    }
  };

  return (
    <div className="row mb-4 conditions">
      <div className={isModalSidebar ? "col-12" : "col-xl-2"}>
        Conditions
        <HelpButton helpKey="components-conditions" />
        <button
          title="Add condition"
          type="button"
          className="btn btn-outline-primary btn-sm border-0 float-end"
          onClick={() => dispatch({ type: "addCondition" })}
          aria-label="Add condition"
        >
          <FontAwesomeIcon icon={faPlusCircle} />
        </button>
      </div>
      <div className={isModalSidebar ? "col-12" : "col-xl-10"}>
        {state.length > 0 ? (
          state.map((condition, index) => (
            <div
              className={`d-flex justify-content-between align-items-center mb-4 pb-4 border-bottom condition condition-${index}`}
              key={condition.UUID}
            >
              <Condition
                event={event}
                index={index}
                condition={condition}
                setCondition={(data) => {
                  dispatch({
                    type: "edit-condition",
                    data,
                  });
                }}
              />
              <button
                title="Remove condition"
                type="button"
                className="btn btn-outline-danger ms-1 border-0 remove-condition"
                onClick={() =>
                  dispatch({
                    type: "removeCondition",
                    conditionId: condition.UUID,
                  })
                }
              >
                <FontAwesomeIcon icon={faMinusCircle} />
              </button>
            </div>
          ))
        ) : (
          <div>
            No conditions defined for this rule.{" "}
            <button
              title="Add condition"
              type="button"
              className="btn btn-link p-0 mb-1"
              onClick={() => dispatch({ type: "addCondition" })}
            >
              Add a condition.
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
